import { render, staticRenderFns } from "./UiSubmit.vue?vue&type=template&id=5bb56121"
import script from "./UiSubmit.vue?vue&type=script&lang=ts"
export * from "./UiSubmit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports